// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grouped-select-group,\n.grouped-select-item {\n  padding: 8px;\n  border-radius: 4px;\n}\n\n.grouped-select-group:not(.selected) {\n  margin-left: 4px;\n}\n\n.grouped-select-item {\n  height: 40px;\n  border: solid 1px transparent;\n}\n\n.grouped-select-item.selected {\n  background-color: #f2f4f4;\n  border: solid 1px #d7dade;\n}\n", ""]);
// Exports
module.exports = exports;
